var map = {
	"./convergence.svg": "8be4",
	"./cross-arrows.svg": "ec9e",
	"./design.svg": "b829",
	"./dizzy.svg": "6d60",
	"./education.svg": "9af8",
	"./foroptero.svg": "27ac",
	"./medical-history.svg": "0de4",
	"./medical.svg": "53b2",
	"./optometry.svg": "3a65",
	"./skills.svg": "189e",
	"./star.svg": "3017",
	"./street-map.svg": "e61e",
	"./stroke.svg": "d25d",
	"./time-and-date.svg": "cfdd",
	"./vision.svg": "9107",
	"./warning.svg": "639a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d197";